export default __webpack_public_path__ + "media/src/assets/images/truck_delivery-5c766682e9e33dcf8e51545b7be0b224.svg";